<template>
    <div>
        <Monitor></Monitor>
    </div>
</template>

<script>
import Monitor from '../../../../vendor/pageup/laravel-health-monitor/src/Components/Monitor'
export default {
    name: "Monitoring",
    components: {
        Monitor
    }

}
</script>

<style scoped>


</style>